<style  scoped>



</style>

<template>
</template>

<script>

import CoreAjax from '../core-ajax/index.vue'
import CoreInput from '../core-input/index.vue'
export default {
    name: "core-ajax-form",
    components: {
        CoreAjax,
        CoreInput
    },
    props: {
        auto: {
            type: Boolean,
            default: !0
        },
        processIn: {
            type: Boolean,
            default: !1
        },
        action: {
            type: String,
            default: ""
        },
        method: {
            type: String,
            default: "post"
        },
        enctype: {
            type: String,
            default: "form"
        },
        content: {
            type: Object,
            default: function() {}
        },
        headers: {
            type: Object,
            default: function() {
                return this.headers
            }
        },
        colorMessage: {
            type: String,
            default: "clear"
        }
    },
    data: function() {
        return {
            inputs: [],
            isFormValid: !0,
            formData: null,
            processIni: this.processIn
        }
    },
    methods: {
        onInputMounted: function(t) {
            this.inputs.push({
                isValid: !1,
                el: t
            })
        },
        onInputSuccess: function(t) {
            this.inputs[t].isValid = !0,
            this.isFormValid = !0
        },
        onInputError: function(t) {
            this.inputs[t].isValid = !1,
            this.isFormValid = !1
        },
        onFormSubmit: function(t) {
            
            t.preventDefault(),
            this.$el.classList.remove("is-form-success"),
            this.$el.classList.remove("is-form-error");
           if(this.content.IsCarrer_force_apply=="true"){
           if(this.$el.querySelector("#jobanswerIn").value=="")
           {
               this.isFormValid=false;
               this.$el.querySelector("#companswer1").innerHTML=this.content.Carrer_force_apply;
           }
           else
           {
                this.isFormValid=true;
           }
           }
            for (var e = 0; e < this.inputs.length; e++){
               
                this.inputs[e].isValid || (this.isFormValid = !1);
            }
            //if (this.isFormValid)
            if (true)
            this.formData = this.serialize(this.$el);
            else
                for (var n = 0; n < this.inputs.length; n++)
                this.inputs[n].isValid || this.inputs[n].el.classList.add("is-error")
        },
        serialize: function(t) {
            var e = void 0,
                n = {};

            //if ("object" == (void 0 === t ? "undefined" : r(t)) && "FORM" == t.nodeName)
            if ("FORM" == t.nodeName)
                for (var i = t.elements.length, s = 0; s < i; s++)
                    {
                    if (e = t.elements[s], e.name && !e.disabled && "file" != e.type && "reset" != e.type && "submit" != e.type && "button" != e.type)
                        if ("select-multiple" == e.type)
                            for (j = t.elements[s].options.length - 1; j >= 0; j--) 
                            e.options[j].selected && (n[e.name] = encodeURIComponent(e.options[j].value));
                        else("checkbox" != e.type && "radio" != e.type || e.checked) && (n[e.name] = e.value);
                      if ("file" === e.type)
                      {
                        if(e.files[0].type=='application/pdf')
                        {

                            n[e.name]=e.files;
                        }
                        else {

                          this.onFormError();
                        }

                       }
                    }

            return n
        },
        onFormSuccess: function(t) {
            this.processIni=false
            t.text==="ok" ||t=="valid"? this.$el.classList.add("is-form-success") : this.onFormError()
        },
        onFormFilesubmit: function(t) {
          this.$el.querySelector("#Custom_text__upload__Careers").innerHTML="";
          
          this.processIni=true
            //t.text==="ok" ||t=="valid"? this.$el.classList.add("is-form-success") : this.onFormError()
        },
        onFormError: function(t) {
            this.$el.classList.remove("is-form-success"),
            this.$el.classList.add("is-form-error")
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/core-ajax-form/index.vue